const Attraction = ({
  className = "",
  color,
}: {
  className?: string;
  color: string;
}) => (
  <svg
    className={className}
    aria-describedby="desc"
    aria-labelledby="title"
    role="img"
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M45.894 40.3l3.077 4.663A17 17 0 0 1 36 55.731V30h8v-6h-8v-6.58a8 8 0 1 0-6 0V24h-8v6h8v25.731a17 17 0 0 1-12.971-10.77l3.077-4.661L10 33.628V39.2a23 23 0 0 0 46 0v-5.572zM33 8.009a2 2 0 1 1-2 2 2 2 0 0 1 2-2z"
      data-name="layer1"
      fill={color}
    />
    <path
      d="M31 10.009a2 2 0 0 1 2-2v-6a8 8 0 0 0-3 15.411V24h-8v6h8v25.731a17 17 0 0 1-12.971-10.77l3.077-4.661L10 33.628V39.2A22.926 22.926 0 0 0 33 62V12.009a2 2 0 0 1-2-2z"
      data-name="opacity"
      fill="#000064"
      opacity=".15"
    />
  </svg>
);

export default Attraction;
